import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Template from "./template";

const dataQuery = graphql`
  query {
    homeJson {
      diagram {
        title
        text
        main_image {
          publicURL
        }
        features {
          display
          link
          text
          title
          image {
            publicURL
          }
        }
        cta_label
        cta_link
        cta_title
      }
    }
  }
`;

function Diagram() {
  const {
    homeJson: { diagram }
  } = useStaticQuery(dataQuery);

  return <Template data={diagram} />;
}

export default Diagram;
